import Layout from '@/views/layout/Layout.vue';

const UPSRouter = {
  path: '/ups',
  redirect: 'noredirect',
  name: 'ups',
  component: Layout,
  meta: {
    title: 'ups'
  },
  children: [
    {
      path: '/ups/equipmentSituation',
      name: 'equipmentSituation',
      component: resolve => require(['@/views/ups/EquipmentSituation.vue'], resolve),
      meta: {
        title: '设备概况',
        requireAuth: true
      },
    }, 
    {
      path: '/ups/equipmentSituation/equipmentplanList/:code',
      name: 'equipmentplanList',
      component: resolve => require(['@/views/ups/EquipmentplanList.vue'], resolve),
      meta: {
        title: '统计列表',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/essentialData',
      name: 'essentialData',
      component: resolve => require(['@/views/ups/EssentialData.vue'], resolve),
      meta: {
        title: '基础数据',
        requireAuth: true
      },
    }, 
    {
      path: '/ups/upsDetailPage/:upsId',
      name: 'upsDetailPage',
      component: resolve => require(['@/views/ups/UpsDetailPage.vue'], resolve),
      meta: {
        title: 'UPS详情',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/realTtimeMonitor',
      name: 'realTtimeMonitor',
      component: resolve => require(['@/views/ups/RealTtimeMonitor.vue'], resolve),
      meta: {
        title: '实时监测',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/realTtimeMonitorInfo/:failureLevel',
      name: 'realTtimeMonitorInfo',
      component: resolve => require(['@/views/ups/RealTtimeMonitorInfo.vue'], resolve),
      meta: {
        title: '告警级别',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/realTtimeMonitor_1',
      name: 'realTtimeMonitor_1',
      component: resolve => require(['@/views/ups/RealTtimeMonitor_ej.vue'], resolve),
      meta: {
        title: '实时监测',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/maintainDynamic',
      name: 'maintainDynamic',
      component: resolve => require(['@/views/ups/MaintainDynamic.vue'], resolve),
      meta: {
        title: '检维修动态',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/maintainDynamic_1',
      name: 'maintainDynamic_1',
      component: resolve => require(['@/views/ups/MaintainDynamic_ej.vue'], resolve),
      meta: {
        title: '检维修动态',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/malfunctionEval',
      name: 'malfunctionEval',
      component: resolve => require(['@/views/ups/MalfunctionEval.vue'], resolve),
      meta: {
        title: '故障评价',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/malfunctionList',
      name: 'malfunctionList',
      component: resolve => require(['@/views/ups/MalfunctionList.vue'], resolve),
      meta: {
        title: '故障设备',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/malfunctionList/:code',
      name: 'malfunctionList1',
      component: resolve => require(['@/views/ups/MalfunctionList1.vue'], resolve),
      meta: {
        title: '故障设备',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/equipmentStatus',
      name: 'equipmentStatus',
      component: resolve => require(['@/views/ups/EquipmentStatus.vue'], resolve),
      meta: {
        title: '设备状态',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/equipmentStatusList/:level',
      name: 'equipmentStatusList',
      component: resolve => require(['@/views/ups/EquipmentStatusList.vue'], resolve),
      meta: {
        title: '状态列表',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/itpm',
      name: 'itpm',
      component: resolve => require(['@/views/ups/ITPM.vue'], resolve),
      meta: {
        title: 'ITPM决策',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/modifySignleRule',
      name: 'modifySignleRule',
      component: resolve => require(['@/views/ups/ModifySignleRule.vue'], resolve),
      meta: {
        title: '设备规则',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/modifyRule',
      name: 'modifyRule',
      component: resolve => require(['@/views/ups/ModifyRule.vue'], resolve),
      meta: {
        title: '全局规则',
        requireAuth: true
      }
    }, 
    {
      path: '/ups/planSchedule',
      name: 'planSchedule',
      component: resolve => require(['@/views/ups/PlanSchedule.vue'], resolve),
      meta: {
        title: '年度计划',
        requireAuth: true
      }
    },

  ]
}

export default UPSRouter;



// WEBPACK FOOTER //
// ./src/router/modules/UPS.js